var _path, _g, _path2, _path3, _g2, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModuleUncompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 79,
    viewBox: "0 0 71 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1291_2039",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 71,
    height: 79
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H70.8391V78.2975H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1291_2039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4026 78.2951C38.6316 78.2951 41.7396 76.46 44.384 74.5326C59.0219 63.8541 62.2172 58.562 63.2661 56.8226C64.4446 54.8699 67.405 50.4173 70.6339 21.3241C71.5251 13.2684 67.552 6.41083 60.1262 3.89429C52.529 1.31333 43.1238 0.00292969 35.4026 0.00292969C27.6814 0.00292969 18.2762 1.31333 10.679 3.89429C3.25316 6.41083 -0.719318 13.2684 0.171281 21.3241C3.40087 50.4173 6.36122 54.8699 7.53913 56.8226C8.58866 58.562 11.7833 63.8541 26.4218 74.5326C29.0656 76.46 32.1736 78.2951 35.4026 78.2951Z",
    fill: "#DCDCDC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0525 13.6826C52.1969 9.95014 43.5504 8.98535 35.2978 8.98535C27.0452 8.98535 18.3988 9.95014 10.5432 13.6826C8.64461 14.5834 7.52309 15.8768 7.72439 17.5774C8.76089 26.2921 12.0129 49.6509 13.6608 52.2015C16.9391 57.2696 28.6425 65.5303 33.3386 68.725C33.915 69.115 34.6052 69.3129 35.2978 69.3129C35.9905 69.3129 36.6807 69.115 37.2571 68.725C41.9532 65.5303 53.6566 57.2696 56.9355 52.2015C58.5853 49.6509 61.8348 26.2921 62.8713 17.5774C63.0726 15.8768 61.9511 14.5834 60.0525 13.6826Z",
    fill: "#CACACA"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1291_2039",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 11,
    width: 43,
    height: 50
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1182 60.8877H56.3921V11.5525H14.1182V60.8877Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1291_2039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7901 58.8125L29.8416 50.4487C28.2958 47.2111 26.1059 44.725 23.2664 42.9842L16.0191 38.4618C15.6775 38.2498 15.4086 37.9543 15.2126 37.5753C15.011 37.1898 14.9102 36.7787 14.9102 36.3355C14.9102 35.8922 15.011 35.4747 15.2126 35.0957C15.4086 34.7167 15.6775 34.4212 16.0191 34.2092L23.2664 29.6868C26.1171 27.9267 28.307 25.4085 29.8416 22.1452L33.7901 13.8391C33.9749 13.4473 34.2325 13.1389 34.563 12.9077C34.8934 12.6829 35.2574 12.5672 35.6439 12.5672C36.0303 12.5672 36.3888 12.6829 36.7248 12.9077C37.0553 13.1389 37.3129 13.4473 37.4977 13.8391L41.4406 22.1452C42.964 25.3957 45.1315 27.9074 47.9542 29.6868L55.2127 34.2092C55.5543 34.4212 55.8232 34.7167 56.0248 35.0957C56.2208 35.4747 56.3216 35.8922 56.3216 36.3355C56.3216 36.7787 56.2208 37.1898 56.0248 37.5753C55.8232 37.9543 55.5543 38.2498 55.2127 38.4618L47.9542 42.9842C45.1427 44.7379 42.9752 47.2303 41.4406 50.4487L37.4977 58.7676C37.3185 59.1658 37.0609 59.4742 36.7304 59.7054C36.4 59.9431 36.0415 60.0588 35.6551 60.0652C35.2686 60.0716 34.9046 59.956 34.5742 59.7376C34.2381 59.5127 33.9749 59.2044 33.7901 58.8125Z",
    fill: "#EFEFEF",
    fillOpacity: 0.1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2539 34.5146C22.2539 33.8848 22.4975 33.2807 22.9312 32.8353C23.3649 32.3899 23.9531 32.1396 24.5664 32.1396H47.6914C48.3047 32.1396 48.8929 32.3899 49.3266 32.8353C49.7603 33.2807 50.0039 33.8848 50.0039 34.5146V39.2646C50.0039 39.8945 49.7603 40.4986 49.3266 40.944C48.8929 41.3894 48.3047 41.6396 47.6914 41.6396H24.5664C23.9531 41.6396 23.3649 41.3894 22.9312 40.944C22.4975 40.4986 22.2539 39.8945 22.2539 39.2646V34.5146Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleUncompleted);
export default __webpack_public_path__ + "static/media/module-uncompleted.1d32b6ca3aecdf963167f98fa8ddef15.svg";
export { ForwardRef as ReactComponent };